import { useState } from "react";
import Welcome from "../components/FIA/Welcome";
import Assessment from "../components/FIA/Assessment";
import Results from "../components/FIA/Results";
// import TestBar from "../components/FIA/TestBar"; // DEV ONLY — delete this import to remove test mode
import { computeResult } from "../data/Scoring";
import api from "../api";
import "../styles/FlowIdentityAssessment.css";

const SCREENS = {
  WELCOME: "welcome",
  ASSESSMENT: "assessment",
  RESULTS: "results",
};

export default function FlowIdentityAssessment() {
  const [screen, setScreen] = useState(SCREENS.WELCOME);
  const [respondent, setRespondent] = useState(null);
  const [result, setResult] = useState(null);
  const [resultId, setResultId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailStatus, setEmailStatus] = useState("idle"); // 'idle' | 'sending' | 'sent' | 'error'

  function handleStart(formData) {
    setRespondent(formData);
    // PRODUCTION: submit {firstName, lastName, email} to your email tool / API here
    setScreen(SCREENS.ASSESSMENT);
  }

  async function handleComplete(answers) {
    // prevent multiple submissions
    if (isSubmitting) return;

    setIsSubmitting(true);

    const r = computeResult(answers);

    const fiaData = {
      respondent,
      answers,
      result: r,
    };

    console.log("Sending FIA data:", fiaData);

    try {
      // const response = await fetch("http://localhost:8000/api/fia/submit", {
      //   method: "POST",
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      //   body: JSON.stringify(fiaData),
      // });
      const response = await api.post("/api/fia/submit", fiaData);

      const data = response.data;

      console.log("FIA backend response:", data);

      setResultId(data.resultId);

      setResult(r);
      setScreen(SCREENS.RESULTS);
    } catch (error) {
      console.error("Failed to submit FIA:", error);
      alert(
        "We couldn't submit your results. Please check your connection and try again.",
      );
    } finally {
      setIsSubmitting(false);
    }
  }

  async function handleEmailResults() {
    if (!resultId) {
      console.error("No resultId available — submission may have failed.");
      setEmailStatus("error");
      return;
    }

    setEmailStatus("sending");

    try {
      await api.post("/api/fia/email-results", {
        resultId,
      });

      setEmailStatus("sent");
    } catch (error) {
      console.error("Failed to email results:", error);
      setEmailStatus("error");
    }
  }

  // DEV ONLY — wire test bar directly to a result
  // function handleTestJump(r) {
  //   setResult(r);
  //   setScreen(SCREENS.RESULTS);
  // }

  return (
    <div className="fia-app">
      {/* DEV ONLY — delete this line (and components/FIA/TestBar.js) before going live */}
      {/* <TestBar onJump={handleTestJump} /> */}

      {screen === SCREENS.WELCOME && <Welcome onStart={handleStart} />}
      {screen === SCREENS.ASSESSMENT && (
        <Assessment onComplete={handleComplete} isSubmitting={isSubmitting} />
      )}
      {screen === SCREENS.RESULTS && result && (
        <Results
          result={result}
          onEmailResults={handleEmailResults}
          emailStatus={emailStatus}
        />
      )}
    </div>
  );
}
